import CommonModal from "@/components/ui/CommonModal";
import { notifyWarning } from "@/utils/notification";
import { Input } from "antd";
import { useCallback } from "react";
import { useDeptSelectorModal } from "./hooks/useDeptSelectorModal";
import styles from "./index.module.less";
import { ModalBody } from "./ModalBody";
import type { DeptItem } from "./type";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  onOk?: (dept: DeptItem) => void;
};

// 部门选择弹窗
export function DeptSelectorModal({ open, onClose, onOk }: Props) {
  const { t } = useTranslation("deptSelectorModal");
  const {
    searchValue,
    selectedDept,
    searchedDepts,
    setSelectedDept,
    reset,
    handleSearch,
    eventType,
    setEventType,
  } = useDeptSelectorModal();

  const handleClose = useCallback(() => {
    onClose();
    reset();
  }, [onClose, reset]);

  const handleOk = useCallback(() => {
    if (!selectedDept) {
      notifyWarning(t("请先选择一个部门"));
      return;
    }
    onOk?.(selectedDept);
    handleClose();
  }, [selectedDept, onOk, handleClose, t]);

  return (
    <CommonModal
      title={
        <div className={styles.header}>
          <span>{t("选择部门")}</span>
          <Input
            className={styles.searchInput}
            placeholder={t("请输入部门名称")}
            value={searchValue}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      }
      open={open}
      onCancel={handleClose}
      style={{ top: 20 }}
      width={800}
      onOk={handleOk}
    >
      <ModalBody
        eventType={eventType}
        searchedList={searchedDepts}
        selectedDept={selectedDept}
        setSelectedDept={setSelectedDept}
        setEventType={setEventType}
        reset={reset}
      />
    </CommonModal>
  );
}
